<template>
  <div class="card card-block options-parent hint-parent"
       @mouseleave="options = hintOpen = false"
       @mouseenter="options = true"
       ref="card"
  >
    <div class="card__img-wrap">
      <span v-if="data.status === 'inactive'" class="disable card__disable">Отключён</span>
      <div class="card__img" :class="{'pointer-none': !edit}">
        <img v-show="loadImg"
             :class="{'card__img-only': data.photo === '/img/photo.svg'}"
             :src="img" alt=""
             v-on:load="onload"
             ref="img"
        >
      </div>
      <div v-if="img !== '/img/photo.svg' && img !== `${url}/img/stub.webp` && editImg">
        <div v-if="edit">
          <div class="card__img-edit-wrap">
            <button @click.prevent="saveImg" class="card__img-edit">Сохранить</button>
          </div>
          <button @click.prevent="destroyCrop" class="options__close d-block">
            <img src="/img/x.svg" alt="">
          </button>
        </div>
        <div v-else class="card__img-edit-wrap">
          <button @click.prevent="crop" class="card__img-edit">Редактировать</button>
        </div>
      </div>
      <Loader v-show="!loadImg"/>
    </div>
    <div class="card__text">
      <span class="card__title mb5">{{data.name}}</span>
      <span v-if="addInfo !== undefined">
        {{addInfo.name}}:
        <span class="c-blue">{{data[addInfo.key]}}</span>
      </span>
    </div>
    <button v-if="hint !== undefined && data[hint] !== undefined && data[hint] !== ''" class="hint__btn" @click="hintOpen = !hintOpen"><img src="/img/i-hint.svg" alt=""></button>
    <div class="hint" v-if="hintOpen && hint !== undefined">
      <p>{{data[hint]}}</p>
    </div>
    <button v-if="next !== undefined"
                 class="block__link"
                 @click="onClick"
    >
    </button>
    <Options v-if="designer"
             :namePage="namePage"
             :id="data._id"
             :parentMouse="options"
             :active="active"
             :data="data"
             @updateData="$emit('updateData')"
    />
  </div>
</template>

<script>
  import Options from "./Options";
  import Loader from "../components/Loader";

  export default {
    name: "Card",
    components: {Loader, Options},
    data() {
      return {
        options: true,
        loadImg: false,
        hintOpen: false,
        edit: false,
        cropper: {},
        url: process.env.VUE_APP_URL
      }
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      next: {
        type: Object
      },
      designer: {
        type: Boolean,
        default: true
      },
      namePage: {
        type: String
      },
      active: {
        type: String
      },
      img: {},
      addInfo: {
        type: Object
      },
      hint: {
        type: String
      },
      editImg: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick() {
        if(this.$route.name.split('-')[0] === 'check') {
          let params = {};
          params.value = this.data.name;
          if (this.$route.name === 'check-brands') {
            params.name = 'Марка';
            this.$store.commit('answers/DELETE_TEST_DATA', 0);
          }
          else if (this.$route.name === 'check-models') {
            params.name = 'Модель';
            this.$store.commit('answers/DELETE_TEST_DATA', 1);
          }
          else if (this.$route.name === 'check-generations') {
            params.name = 'Поколение';
            this.$store.commit('answers/DELETE_TEST_DATA', 3);
          }
          else if (this.$route.name === 'check-answers') {
            params.name = this.$parent.mainTitle;
            for (let i = 4; i < this.$store.state.answers.testData.length; i++) {
              if (params.name === this.$store.state.answers.testData[i].name) {
                this.$store.commit('answers/DELETE_TEST_DATA', i);
                break;
              }
            }
          }
          this.$store.commit('answers/CHANGE_TEST_DATA', params)
        }
        this.$router.push(this.next);
      },
      onload() {
        this.loadImg = true;
      },
      crop() {
        let $image = $(this.$refs.img);
        $image.cropper({
          aspectRatio: 508 / 340,
          dragMode: 'move',
          viewMode: 3,
          cropBoxMovable: false,
          cropBoxResizable: false,
          minCropBoxWidth: this.$refs.card.clientWidth,
          minCropBoxHeight: this.$refs.card.clientHeight
        });
        this.cropper = $image.data('cropper');
        this.cropper.crop();
        this.edit = true;
      },
      saveImg() {
        const canvasData = this.cropper.getCroppedCanvas();
        this.urlToFile(canvasData.toDataURL('image/png'), 'hello.png', 'image/png')
          .then((file) =>{
            this.$emit('changeImg', {target: {files: [file]}});
          });
        this.destroyCrop();
      },
      urlToFile(url, filename, mimeType){
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename, {type:mimeType});})
        );
      },
      destroyCrop() {
        this.edit = false;
        this.cropper.destroy();
        $(this.$refs.img).data('cropper', null);
      }
    },
    watch: {
      img() {
        if (this.edit) {
          this.destroyCrop();
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .card-block {
    width: $cardWidth;
    margin: 8px;
    @media (max-width: 767px) {
      width: calc(100% / 2 - 16px);
    }
    @media (max-width: 400px) {
      width: 100%;
    }
  }

  .card {
    position: relative;
    background-color: #fff;
    box-shadow: $shadow;
    transition: $transition;
    &__disable {
      position: absolute;
      z-index: 1;
      bottom: 8px;
      left: 8px;
      margin: 0 !important;
    }
    &__img {
      display: flex;
      justify-content: center;
      height: 170px;
      @media (max-width: 767px) {
        height: 110px;
      }
      &-wrap {
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &:hover {
          .card__img-edit {
            transform: translateY(0);
          }
        }
      }
      &--small {
        margin-top: 25px;
        max-width: 80%;
      }
      &-only {
        width: unset !important;
        height: unset !important;
        margin-top: auto;
        margin-bottom: -5px;
        object-fit: unset !important;
      }
      &-edit {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #fff;
        background-color: transparentize($black, 0.7);
        border: none;
        transform: translateY(100%);
        transition: $transition;
        cursor: pointer;
        &-wrap {
          position: absolute;
          z-index: 7;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 30px;
          overflow: hidden;
        }
      }
    }
    &__text {
      display: flex;
      flex-direction: column;
      height: 90px;
      padding: 25px 15px 15px;
      text-align: center;
      @media (max-width: 767px) {
        padding: 15px;
        height: 80px;
      }
    }
  }

  .hint {
    position: absolute;
    z-index: 10;
    top: 50px;
    left: -20px;
    max-width: 400px;
    margin-right: -130px;
    padding: 17px 37px;
    background-color: #fff;
    box-shadow: $shadow;
    @media (max-width: 575px) {
      left: -10px;
      max-width: 190px;
      margin-right: 0;
      padding: 10px 20px;
    }
    &-parent {
      position: relative;
      &:hover {
        .hint__btn {
          display: block;
        }
      }
    }
    &__btn {
      display: none;
      position: absolute;
      z-index: 10;
      top: 8px;
      left: 8px;
      padding: 0;
      background-color: transparent;
      border: none;
      cursor: pointer;
      @media (max-width: 767px) {
        display: block;
      }
    }
  }
</style>